import { Component } from 'react';
import { isNull, get } from 'lodash/fp';
import { connect } from 'react-redux';
import { DateTime } from '@mews/framework';
import { IconName } from '@optimus-web/core';
import { NotificationState } from '@mews-commander/legacy-data-structures';
import { openNotification, openTaskDetail, OpenTaskDetailParams } from '../actions/handlers';
import { NotificationWrapper } from './style';
import {
    SimpleNotification,
    MessageNotification,
    ServiceOrderNotification,
    DeviceCommandNotification,
} from './NotificationType';

interface Props {
    openNotification?: $TSFixMeFunction;
    openTaskDetail: ({ taskId, profileId }: OpenTaskDetailParams) => void;
    id?: string;
    profileId?: string;
    state?: number;
    event?: {};
    export?: {};
    command?: {};
    text?: string;
    createdDateTime?: DateTime;
    authorImageUrl?: string;
    authorName?: string;
    close?: $TSFixMeFunction;
    title?: string;
    highlight: boolean;
    task?: { id: string };
}

class NotificationItem extends Component<Props> {
    handleNotificationClick = () => {
        const { close, id, profileId } = this.props;

        // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
        close();
        // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
        this.props.openNotification({ id, profileId });
    };

    handleTaskClick = () => {
        const { close, task, profileId } = this.props;
        const taskId = task?.id;
        if (!taskId || !profileId) return null;
        close?.();
        this.props.openTaskDetail({ taskId, profileId });
    };

    render() {
        const { state, event, text, createdDateTime, authorImageUrl, authorName, command, title, highlight, task } =
            this.props;
        const isSeen = state === NotificationState.Seen.value;

        const notificationProps = { isSeen, createdDateTime, onClick: this.handleNotificationClick };
        const notificationTaskProps = { ...notificationProps, onClick: this.handleTaskClick };

        let notificationType;
        if (!isNull(this.props.export)) {
            notificationType = (
                <SimpleNotification
                    {...notificationProps}
                    {...this.props.export}
                    title={title}
                    text={text}
                    icon={IconName.Exports}
                    type="export"
                />
            );
        } else if (!isNull(task)) {
            notificationType = (
                <SimpleNotification
                    {...notificationTaskProps}
                    {...task}
                    title={title}
                    text={text}
                    icon={IconName.Tasks}
                    type="task"
                />
            );
        } else if (!isNull(command)) {
            notificationType = <DeviceCommandNotification {...notificationProps} {...command} title={title} />;
        } else if (get('serviceOrderEventType')(event)) {
            notificationType = <ServiceOrderNotification {...notificationProps} {...event} />;
        } else {
            notificationType = (
                <MessageNotification
                    {...notificationProps}
                    text={text}
                    authorImageUrl={authorImageUrl}
                    authorName={authorName}
                />
            );
        }

        return <NotificationWrapper highlight={highlight}>{notificationType}</NotificationWrapper>;
    }
}

export default connect(undefined, {
    openNotification,
    openTaskDetail,
})(NotificationItem);
